/* eslint-disable */
import _m0 from 'protobufjs/minimal';
export const protobufPackage = 'vengar.cap';
export var CAPProcess;
(function (CAPProcess) {
    CAPProcess[CAPProcess["UndefProcess"] = 0] = "UndefProcess";
    CAPProcess[CAPProcess["Match"] = 1] = "Match";
    CAPProcess[CAPProcess["MatchXTimes"] = 2] = "MatchXTimes";
    CAPProcess[CAPProcess["MultiMatch"] = 3] = "MultiMatch";
    CAPProcess[CAPProcess["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CAPProcess || (CAPProcess = {}));
export function cAPProcessFromJSON(object) {
    switch (object) {
        case 0:
        case 'UndefProcess':
            return CAPProcess.UndefProcess;
        case 1:
        case 'Match':
            return CAPProcess.Match;
        case 2:
        case 'MatchXTimes':
            return CAPProcess.MatchXTimes;
        case 3:
        case 'MultiMatch':
            return CAPProcess.MultiMatch;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CAPProcess.UNRECOGNIZED;
    }
}
export function cAPProcessToJSON(object) {
    switch (object) {
        case CAPProcess.UndefProcess:
            return 'UndefProcess';
        case CAPProcess.Match:
            return 'Match';
        case CAPProcess.MatchXTimes:
            return 'MatchXTimes';
        case CAPProcess.MultiMatch:
            return 'MultiMatch';
        case CAPProcess.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
export var CAPSeverity;
(function (CAPSeverity) {
    CAPSeverity[CAPSeverity["UndefSeverity"] = 0] = "UndefSeverity";
    CAPSeverity[CAPSeverity["Warn"] = 1] = "Warn";
    CAPSeverity[CAPSeverity["Prompt"] = 2] = "Prompt";
    CAPSeverity[CAPSeverity["MustSecure"] = 3] = "MustSecure";
    CAPSeverity[CAPSeverity["NoSend"] = 4] = "NoSend";
    CAPSeverity[CAPSeverity["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CAPSeverity || (CAPSeverity = {}));
export function cAPSeverityFromJSON(object) {
    switch (object) {
        case 0:
        case 'UndefSeverity':
            return CAPSeverity.UndefSeverity;
        case 1:
        case 'Warn':
            return CAPSeverity.Warn;
        case 2:
        case 'Prompt':
            return CAPSeverity.Prompt;
        case 3:
        case 'MustSecure':
            return CAPSeverity.MustSecure;
        case 4:
        case 'NoSend':
            return CAPSeverity.NoSend;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CAPSeverity.UNRECOGNIZED;
    }
}
export function cAPSeverityToJSON(object) {
    switch (object) {
        case CAPSeverity.UndefSeverity:
            return 'UndefSeverity';
        case CAPSeverity.Warn:
            return 'Warn';
        case CAPSeverity.Prompt:
            return 'Prompt';
        case CAPSeverity.MustSecure:
            return 'MustSecure';
        case CAPSeverity.NoSend:
            return 'NoSend';
        case CAPSeverity.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
export var CAPDRM;
(function (CAPDRM) {
    CAPDRM[CAPDRM["UndefDRM"] = 0] = "UndefDRM";
    CAPDRM[CAPDRM["DisallowForward"] = 1] = "DisallowForward";
    CAPDRM[CAPDRM["DisallowCopy"] = 2] = "DisallowCopy";
    CAPDRM[CAPDRM["DisallowPrint"] = 3] = "DisallowPrint";
    CAPDRM[CAPDRM["DisallowSave"] = 4] = "DisallowSave";
    CAPDRM[CAPDRM["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CAPDRM || (CAPDRM = {}));
export function cAPDRMFromJSON(object) {
    switch (object) {
        case 0:
        case 'UndefDRM':
            return CAPDRM.UndefDRM;
        case 1:
        case 'DisallowForward':
            return CAPDRM.DisallowForward;
        case 2:
        case 'DisallowCopy':
            return CAPDRM.DisallowCopy;
        case 3:
        case 'DisallowPrint':
            return CAPDRM.DisallowPrint;
        case 4:
        case 'DisallowSave':
            return CAPDRM.DisallowSave;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CAPDRM.UNRECOGNIZED;
    }
}
export function cAPDRMToJSON(object) {
    switch (object) {
        case CAPDRM.UndefDRM:
            return 'UndefDRM';
        case CAPDRM.DisallowForward:
            return 'DisallowForward';
        case CAPDRM.DisallowCopy:
            return 'DisallowCopy';
        case CAPDRM.DisallowPrint:
            return 'DisallowPrint';
        case CAPDRM.DisallowSave:
            return 'DisallowSave';
        case CAPDRM.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
export var CAPType;
(function (CAPType) {
    CAPType[CAPType["UndefType"] = 0] = "UndefType";
    CAPType[CAPType["GIIN"] = 1] = "GIIN";
    CAPType[CAPType["PHI"] = 2] = "PHI";
    CAPType[CAPType["I3"] = 3] = "I3";
    CAPType[CAPType["FinBank"] = 4] = "FinBank";
    CAPType[CAPType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CAPType || (CAPType = {}));
export function cAPTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'UndefType':
            return CAPType.UndefType;
        case 1:
        case 'GIIN':
            return CAPType.GIIN;
        case 2:
        case 'PHI':
            return CAPType.PHI;
        case 3:
        case 'I3':
            return CAPType.I3;
        case 4:
        case 'FinBank':
            return CAPType.FinBank;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CAPType.UNRECOGNIZED;
    }
}
export function cAPTypeToJSON(object) {
    switch (object) {
        case CAPType.UndefType:
            return 'UndefType';
        case CAPType.GIIN:
            return 'GIIN';
        case CAPType.PHI:
            return 'PHI';
        case CAPType.I3:
            return 'I3';
        case CAPType.FinBank:
            return 'FinBank';
        case CAPType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
export var CAPIDEnum;
(function (CAPIDEnum) {
    CAPIDEnum[CAPIDEnum["UNDEFINED"] = 0] = "UNDEFINED";
    CAPIDEnum[CAPIDEnum["FORMATTED_USSSN"] = 1] = "FORMATTED_USSSN";
    CAPIDEnum[CAPIDEnum["USSSN_TAGS"] = 2] = "USSSN_TAGS";
    CAPIDEnum[CAPIDEnum["FORMATTED_USTIN"] = 3] = "FORMATTED_USTIN";
    CAPIDEnum[CAPIDEnum["USTIN_TAGS"] = 4] = "USTIN_TAGS";
    CAPIDEnum[CAPIDEnum["FORMATTED_USEIN"] = 5] = "FORMATTED_USEIN";
    CAPIDEnum[CAPIDEnum["USEIN_TAGS"] = 6] = "USEIN_TAGS";
    CAPIDEnum[CAPIDEnum["AL_DL"] = 7] = "AL_DL";
    CAPIDEnum[CAPIDEnum["AK_DL"] = 8] = "AK_DL";
    CAPIDEnum[CAPIDEnum["AZ_DL"] = 9] = "AZ_DL";
    CAPIDEnum[CAPIDEnum["AR_DL"] = 10] = "AR_DL";
    CAPIDEnum[CAPIDEnum["CA_DL"] = 11] = "CA_DL";
    CAPIDEnum[CAPIDEnum["CO_DL"] = 12] = "CO_DL";
    CAPIDEnum[CAPIDEnum["CT_DL"] = 13] = "CT_DL";
    CAPIDEnum[CAPIDEnum["DE_DL"] = 14] = "DE_DL";
    CAPIDEnum[CAPIDEnum["DC_DL"] = 15] = "DC_DL";
    CAPIDEnum[CAPIDEnum["FL_DL"] = 16] = "FL_DL";
    CAPIDEnum[CAPIDEnum["GA_DL"] = 17] = "GA_DL";
    CAPIDEnum[CAPIDEnum["HI_DL"] = 18] = "HI_DL";
    CAPIDEnum[CAPIDEnum["ID_DL"] = 19] = "ID_DL";
    CAPIDEnum[CAPIDEnum["IL_DL"] = 20] = "IL_DL";
    CAPIDEnum[CAPIDEnum["IN_DL"] = 21] = "IN_DL";
    CAPIDEnum[CAPIDEnum["IA_DL"] = 22] = "IA_DL";
    CAPIDEnum[CAPIDEnum["KS_DL"] = 23] = "KS_DL";
    CAPIDEnum[CAPIDEnum["KY_DL"] = 24] = "KY_DL";
    CAPIDEnum[CAPIDEnum["LA_DL"] = 25] = "LA_DL";
    CAPIDEnum[CAPIDEnum["ME_DL"] = 26] = "ME_DL";
    CAPIDEnum[CAPIDEnum["MD_DL"] = 27] = "MD_DL";
    CAPIDEnum[CAPIDEnum["MA_DL"] = 28] = "MA_DL";
    CAPIDEnum[CAPIDEnum["MI_DL"] = 29] = "MI_DL";
    CAPIDEnum[CAPIDEnum["MN_DL"] = 30] = "MN_DL";
    CAPIDEnum[CAPIDEnum["MS_DL"] = 31] = "MS_DL";
    CAPIDEnum[CAPIDEnum["MO_DL"] = 32] = "MO_DL";
    CAPIDEnum[CAPIDEnum["MT_DL"] = 33] = "MT_DL";
    CAPIDEnum[CAPIDEnum["NE_DL"] = 34] = "NE_DL";
    CAPIDEnum[CAPIDEnum["NV_DL"] = 35] = "NV_DL";
    CAPIDEnum[CAPIDEnum["NH_DL"] = 36] = "NH_DL";
    CAPIDEnum[CAPIDEnum["NJ_DL"] = 37] = "NJ_DL";
    CAPIDEnum[CAPIDEnum["NM_DL"] = 38] = "NM_DL";
    CAPIDEnum[CAPIDEnum["NY_DL"] = 39] = "NY_DL";
    CAPIDEnum[CAPIDEnum["NC_DL"] = 40] = "NC_DL";
    CAPIDEnum[CAPIDEnum["ND_DL"] = 41] = "ND_DL";
    CAPIDEnum[CAPIDEnum["OH_DL"] = 42] = "OH_DL";
    CAPIDEnum[CAPIDEnum["OK_DL"] = 43] = "OK_DL";
    CAPIDEnum[CAPIDEnum["OR_DL"] = 44] = "OR_DL";
    CAPIDEnum[CAPIDEnum["PA_DL"] = 45] = "PA_DL";
    CAPIDEnum[CAPIDEnum["RI_DL"] = 46] = "RI_DL";
    CAPIDEnum[CAPIDEnum["SC_DL"] = 47] = "SC_DL";
    CAPIDEnum[CAPIDEnum["SD_DL"] = 48] = "SD_DL";
    CAPIDEnum[CAPIDEnum["TN_DL"] = 49] = "TN_DL";
    CAPIDEnum[CAPIDEnum["TX_DL"] = 50] = "TX_DL";
    CAPIDEnum[CAPIDEnum["UT_DL"] = 51] = "UT_DL";
    CAPIDEnum[CAPIDEnum["VT_DL"] = 52] = "VT_DL";
    CAPIDEnum[CAPIDEnum["VA_DL"] = 53] = "VA_DL";
    CAPIDEnum[CAPIDEnum["WA_DL"] = 54] = "WA_DL";
    CAPIDEnum[CAPIDEnum["WV_DL"] = 55] = "WV_DL";
    CAPIDEnum[CAPIDEnum["WI_DL"] = 56] = "WI_DL";
    CAPIDEnum[CAPIDEnum["WY_DL"] = 57] = "WY_DL";
    CAPIDEnum[CAPIDEnum["US_PASSPORT"] = 58] = "US_PASSPORT";
    CAPIDEnum[CAPIDEnum["US_DATEONLY"] = 59] = "US_DATEONLY";
    CAPIDEnum[CAPIDEnum["DATE_OF"] = 60] = "DATE_OF";
    CAPIDEnum[CAPIDEnum["DATE_OF_BIRTH"] = 61] = "DATE_OF_BIRTH";
    CAPIDEnum[CAPIDEnum["DATE_OF_SERVICE"] = 62] = "DATE_OF_SERVICE";
    CAPIDEnum[CAPIDEnum["DATE_OF_ADMISSION"] = 63] = "DATE_OF_ADMISSION";
    CAPIDEnum[CAPIDEnum["DATE_OF_DISCHARGE"] = 64] = "DATE_OF_DISCHARGE";
    CAPIDEnum[CAPIDEnum["DATE_OF_DEATH"] = 65] = "DATE_OF_DEATH";
    CAPIDEnum[CAPIDEnum["RECEIVED_DATE"] = 66] = "RECEIVED_DATE";
    CAPIDEnum[CAPIDEnum["ORDER_DATE"] = 67] = "ORDER_DATE";
    CAPIDEnum[CAPIDEnum["EXP_DATE"] = 68] = "EXP_DATE";
    CAPIDEnum[CAPIDEnum["UNFORMATED_NPI"] = 69] = "UNFORMATED_NPI";
    CAPIDEnum[CAPIDEnum["FORMATTED_NPI"] = 70] = "FORMATTED_NPI";
    CAPIDEnum[CAPIDEnum["ZIPFULLONLY"] = 71] = "ZIPFULLONLY";
    CAPIDEnum[CAPIDEnum["ZIPWITHTAG"] = 72] = "ZIPWITHTAG";
    CAPIDEnum[CAPIDEnum["FULLNAMEWITHTAG"] = 73] = "FULLNAMEWITHTAG";
    CAPIDEnum[CAPIDEnum["ADDRESSONLY"] = 74] = "ADDRESSONLY";
    CAPIDEnum[CAPIDEnum["ADDRESSWITHTAGS"] = 75] = "ADDRESSWITHTAGS";
    CAPIDEnum[CAPIDEnum["AGEWITHTAGS"] = 76] = "AGEWITHTAGS";
    CAPIDEnum[CAPIDEnum["PHONEFORMATTED"] = 77] = "PHONEFORMATTED";
    CAPIDEnum[CAPIDEnum["PHONEWITHTAGS"] = 78] = "PHONEWITHTAGS";
    CAPIDEnum[CAPIDEnum["EMAILFORMATTED"] = 79] = "EMAILFORMATTED";
    CAPIDEnum[CAPIDEnum["EMAILWITHTAGS"] = 80] = "EMAILWITHTAGS";
    CAPIDEnum[CAPIDEnum["AL_LP"] = 81] = "AL_LP";
    CAPIDEnum[CAPIDEnum["AK_LP"] = 82] = "AK_LP";
    CAPIDEnum[CAPIDEnum["AZ_LP"] = 83] = "AZ_LP";
    CAPIDEnum[CAPIDEnum["AR_LP"] = 84] = "AR_LP";
    CAPIDEnum[CAPIDEnum["CA_LP"] = 85] = "CA_LP";
    CAPIDEnum[CAPIDEnum["CO_LP"] = 86] = "CO_LP";
    CAPIDEnum[CAPIDEnum["CT_LP"] = 87] = "CT_LP";
    CAPIDEnum[CAPIDEnum["DE_LP"] = 88] = "DE_LP";
    CAPIDEnum[CAPIDEnum["DC_LP"] = 89] = "DC_LP";
    CAPIDEnum[CAPIDEnum["FL_LP"] = 90] = "FL_LP";
    CAPIDEnum[CAPIDEnum["GA_LP"] = 91] = "GA_LP";
    CAPIDEnum[CAPIDEnum["HI_LP"] = 92] = "HI_LP";
    CAPIDEnum[CAPIDEnum["ID_LP"] = 93] = "ID_LP";
    CAPIDEnum[CAPIDEnum["IL_LP"] = 94] = "IL_LP";
    CAPIDEnum[CAPIDEnum["IN_LP"] = 95] = "IN_LP";
    CAPIDEnum[CAPIDEnum["IA_LP"] = 96] = "IA_LP";
    CAPIDEnum[CAPIDEnum["KS_LP"] = 97] = "KS_LP";
    CAPIDEnum[CAPIDEnum["KY_LP"] = 98] = "KY_LP";
    CAPIDEnum[CAPIDEnum["LA_LP"] = 99] = "LA_LP";
    CAPIDEnum[CAPIDEnum["ME_LP"] = 100] = "ME_LP";
    CAPIDEnum[CAPIDEnum["MD_LP"] = 101] = "MD_LP";
    CAPIDEnum[CAPIDEnum["MA_LP"] = 102] = "MA_LP";
    CAPIDEnum[CAPIDEnum["MI_LP"] = 103] = "MI_LP";
    CAPIDEnum[CAPIDEnum["MN_LP"] = 104] = "MN_LP";
    CAPIDEnum[CAPIDEnum["MS_LP"] = 105] = "MS_LP";
    CAPIDEnum[CAPIDEnum["MO_LP"] = 106] = "MO_LP";
    CAPIDEnum[CAPIDEnum["MT_LP"] = 107] = "MT_LP";
    CAPIDEnum[CAPIDEnum["NE_LP"] = 108] = "NE_LP";
    CAPIDEnum[CAPIDEnum["NV_LP"] = 109] = "NV_LP";
    CAPIDEnum[CAPIDEnum["NH_LP"] = 110] = "NH_LP";
    CAPIDEnum[CAPIDEnum["NJ_LP"] = 111] = "NJ_LP";
    CAPIDEnum[CAPIDEnum["NM_LP"] = 112] = "NM_LP";
    CAPIDEnum[CAPIDEnum["NY_LP"] = 113] = "NY_LP";
    CAPIDEnum[CAPIDEnum["NC_LP"] = 114] = "NC_LP";
    CAPIDEnum[CAPIDEnum["ND_LP"] = 115] = "ND_LP";
    CAPIDEnum[CAPIDEnum["OH_LP"] = 116] = "OH_LP";
    CAPIDEnum[CAPIDEnum["OK_LP"] = 117] = "OK_LP";
    CAPIDEnum[CAPIDEnum["OR_LP"] = 118] = "OR_LP";
    CAPIDEnum[CAPIDEnum["PA_LP"] = 119] = "PA_LP";
    CAPIDEnum[CAPIDEnum["RI_LP"] = 120] = "RI_LP";
    CAPIDEnum[CAPIDEnum["SC_LP"] = 121] = "SC_LP";
    CAPIDEnum[CAPIDEnum["SD_LP"] = 122] = "SD_LP";
    CAPIDEnum[CAPIDEnum["TN_LP"] = 123] = "TN_LP";
    CAPIDEnum[CAPIDEnum["TX_LP"] = 124] = "TX_LP";
    CAPIDEnum[CAPIDEnum["UT_LP"] = 125] = "UT_LP";
    CAPIDEnum[CAPIDEnum["VT_LP"] = 126] = "VT_LP";
    CAPIDEnum[CAPIDEnum["VA_LP"] = 127] = "VA_LP";
    CAPIDEnum[CAPIDEnum["WA_LP"] = 128] = "WA_LP";
    CAPIDEnum[CAPIDEnum["WV_LP"] = 129] = "WV_LP";
    CAPIDEnum[CAPIDEnum["WI_LP"] = 130] = "WI_LP";
    CAPIDEnum[CAPIDEnum["WY_LP"] = 131] = "WY_LP";
    CAPIDEnum[CAPIDEnum["VIN_WITH_TAGS"] = 132] = "VIN_WITH_TAGS";
    CAPIDEnum[CAPIDEnum["URL_ONLY"] = 133] = "URL_ONLY";
    CAPIDEnum[CAPIDEnum["URL_WITH_TAGS"] = 134] = "URL_WITH_TAGS";
    CAPIDEnum[CAPIDEnum["IPONLY"] = 135] = "IPONLY";
    CAPIDEnum[CAPIDEnum["IP_WITH_TAGS"] = 136] = "IP_WITH_TAGS";
    CAPIDEnum[CAPIDEnum["ACCT_SECURITY_TAGS"] = 137] = "ACCT_SECURITY_TAGS";
    CAPIDEnum[CAPIDEnum["VISA_CC"] = 138] = "VISA_CC";
    CAPIDEnum[CAPIDEnum["MASTERCARD_CC"] = 139] = "MASTERCARD_CC";
    CAPIDEnum[CAPIDEnum["AMEX_CC"] = 140] = "AMEX_CC";
    CAPIDEnum[CAPIDEnum["DISCOVER_CC"] = 141] = "DISCOVER_CC";
    CAPIDEnum[CAPIDEnum["ALL_CC"] = 142] = "ALL_CC";
    CAPIDEnum[CAPIDEnum["IBAN_ONLY"] = 143] = "IBAN_ONLY";
    CAPIDEnum[CAPIDEnum["IBAN_TAGS"] = 144] = "IBAN_TAGS";
    CAPIDEnum[CAPIDEnum["USBAI_NUMONLY"] = 145] = "USBAI_NUMONLY";
    CAPIDEnum[CAPIDEnum["USBAI_TAGSONLY"] = 146] = "USBAI_TAGSONLY";
    CAPIDEnum[CAPIDEnum["USBAI_TAGS_NUMBER"] = 147] = "USBAI_TAGS_NUMBER";
    CAPIDEnum[CAPIDEnum["MCS_TAGSIDC910"] = 148] = "MCS_TAGSIDC910";
    CAPIDEnum[CAPIDEnum["WTI_TAGS_SWIFT"] = 149] = "WTI_TAGS_SWIFT";
    CAPIDEnum[CAPIDEnum["SSN9_DLN"] = 150] = "SSN9_DLN";
    CAPIDEnum[CAPIDEnum["TIN9_DLN"] = 151] = "TIN9_DLN";
    CAPIDEnum[CAPIDEnum["EIN9_DLN"] = 152] = "EIN9_DLN";
    CAPIDEnum[CAPIDEnum["SSNTINEIN9_DLN"] = 153] = "SSNTINEIN9_DLN";
    CAPIDEnum[CAPIDEnum["SSNTINEIN9_PASSPORT"] = 154] = "SSNTINEIN9_PASSPORT";
    CAPIDEnum[CAPIDEnum["SSNTINEIN9_MED_TERMS"] = 155] = "SSNTINEIN9_MED_TERMS";
    CAPIDEnum[CAPIDEnum["SSNTINEIN9_CC"] = 156] = "SSNTINEIN9_CC";
    CAPIDEnum[CAPIDEnum["SSNTINEIN9_BANK_ACCT"] = 157] = "SSNTINEIN9_BANK_ACCT";
    CAPIDEnum[CAPIDEnum["UNSCANNED_FILES"] = 158] = "UNSCANNED_FILES";
    CAPIDEnum[CAPIDEnum["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CAPIDEnum || (CAPIDEnum = {}));
export function cAPIDEnumFromJSON(object) {
    switch (object) {
        case 0:
        case 'UNDEFINED':
            return CAPIDEnum.UNDEFINED;
        case 1:
        case 'FORMATTED_USSSN':
            return CAPIDEnum.FORMATTED_USSSN;
        case 2:
        case 'USSSN_TAGS':
            return CAPIDEnum.USSSN_TAGS;
        case 3:
        case 'FORMATTED_USTIN':
            return CAPIDEnum.FORMATTED_USTIN;
        case 4:
        case 'USTIN_TAGS':
            return CAPIDEnum.USTIN_TAGS;
        case 5:
        case 'FORMATTED_USEIN':
            return CAPIDEnum.FORMATTED_USEIN;
        case 6:
        case 'USEIN_TAGS':
            return CAPIDEnum.USEIN_TAGS;
        case 7:
        case 'AL_DL':
            return CAPIDEnum.AL_DL;
        case 8:
        case 'AK_DL':
            return CAPIDEnum.AK_DL;
        case 9:
        case 'AZ_DL':
            return CAPIDEnum.AZ_DL;
        case 10:
        case 'AR_DL':
            return CAPIDEnum.AR_DL;
        case 11:
        case 'CA_DL':
            return CAPIDEnum.CA_DL;
        case 12:
        case 'CO_DL':
            return CAPIDEnum.CO_DL;
        case 13:
        case 'CT_DL':
            return CAPIDEnum.CT_DL;
        case 14:
        case 'DE_DL':
            return CAPIDEnum.DE_DL;
        case 15:
        case 'DC_DL':
            return CAPIDEnum.DC_DL;
        case 16:
        case 'FL_DL':
            return CAPIDEnum.FL_DL;
        case 17:
        case 'GA_DL':
            return CAPIDEnum.GA_DL;
        case 18:
        case 'HI_DL':
            return CAPIDEnum.HI_DL;
        case 19:
        case 'ID_DL':
            return CAPIDEnum.ID_DL;
        case 20:
        case 'IL_DL':
            return CAPIDEnum.IL_DL;
        case 21:
        case 'IN_DL':
            return CAPIDEnum.IN_DL;
        case 22:
        case 'IA_DL':
            return CAPIDEnum.IA_DL;
        case 23:
        case 'KS_DL':
            return CAPIDEnum.KS_DL;
        case 24:
        case 'KY_DL':
            return CAPIDEnum.KY_DL;
        case 25:
        case 'LA_DL':
            return CAPIDEnum.LA_DL;
        case 26:
        case 'ME_DL':
            return CAPIDEnum.ME_DL;
        case 27:
        case 'MD_DL':
            return CAPIDEnum.MD_DL;
        case 28:
        case 'MA_DL':
            return CAPIDEnum.MA_DL;
        case 29:
        case 'MI_DL':
            return CAPIDEnum.MI_DL;
        case 30:
        case 'MN_DL':
            return CAPIDEnum.MN_DL;
        case 31:
        case 'MS_DL':
            return CAPIDEnum.MS_DL;
        case 32:
        case 'MO_DL':
            return CAPIDEnum.MO_DL;
        case 33:
        case 'MT_DL':
            return CAPIDEnum.MT_DL;
        case 34:
        case 'NE_DL':
            return CAPIDEnum.NE_DL;
        case 35:
        case 'NV_DL':
            return CAPIDEnum.NV_DL;
        case 36:
        case 'NH_DL':
            return CAPIDEnum.NH_DL;
        case 37:
        case 'NJ_DL':
            return CAPIDEnum.NJ_DL;
        case 38:
        case 'NM_DL':
            return CAPIDEnum.NM_DL;
        case 39:
        case 'NY_DL':
            return CAPIDEnum.NY_DL;
        case 40:
        case 'NC_DL':
            return CAPIDEnum.NC_DL;
        case 41:
        case 'ND_DL':
            return CAPIDEnum.ND_DL;
        case 42:
        case 'OH_DL':
            return CAPIDEnum.OH_DL;
        case 43:
        case 'OK_DL':
            return CAPIDEnum.OK_DL;
        case 44:
        case 'OR_DL':
            return CAPIDEnum.OR_DL;
        case 45:
        case 'PA_DL':
            return CAPIDEnum.PA_DL;
        case 46:
        case 'RI_DL':
            return CAPIDEnum.RI_DL;
        case 47:
        case 'SC_DL':
            return CAPIDEnum.SC_DL;
        case 48:
        case 'SD_DL':
            return CAPIDEnum.SD_DL;
        case 49:
        case 'TN_DL':
            return CAPIDEnum.TN_DL;
        case 50:
        case 'TX_DL':
            return CAPIDEnum.TX_DL;
        case 51:
        case 'UT_DL':
            return CAPIDEnum.UT_DL;
        case 52:
        case 'VT_DL':
            return CAPIDEnum.VT_DL;
        case 53:
        case 'VA_DL':
            return CAPIDEnum.VA_DL;
        case 54:
        case 'WA_DL':
            return CAPIDEnum.WA_DL;
        case 55:
        case 'WV_DL':
            return CAPIDEnum.WV_DL;
        case 56:
        case 'WI_DL':
            return CAPIDEnum.WI_DL;
        case 57:
        case 'WY_DL':
            return CAPIDEnum.WY_DL;
        case 58:
        case 'US_PASSPORT':
            return CAPIDEnum.US_PASSPORT;
        case 59:
        case 'US_DATEONLY':
            return CAPIDEnum.US_DATEONLY;
        case 60:
        case 'DATE_OF':
            return CAPIDEnum.DATE_OF;
        case 61:
        case 'DATE_OF_BIRTH':
            return CAPIDEnum.DATE_OF_BIRTH;
        case 62:
        case 'DATE_OF_SERVICE':
            return CAPIDEnum.DATE_OF_SERVICE;
        case 63:
        case 'DATE_OF_ADMISSION':
            return CAPIDEnum.DATE_OF_ADMISSION;
        case 64:
        case 'DATE_OF_DISCHARGE':
            return CAPIDEnum.DATE_OF_DISCHARGE;
        case 65:
        case 'DATE_OF_DEATH':
            return CAPIDEnum.DATE_OF_DEATH;
        case 66:
        case 'RECEIVED_DATE':
            return CAPIDEnum.RECEIVED_DATE;
        case 67:
        case 'ORDER_DATE':
            return CAPIDEnum.ORDER_DATE;
        case 68:
        case 'EXP_DATE':
            return CAPIDEnum.EXP_DATE;
        case 69:
        case 'UNFORMATED_NPI':
            return CAPIDEnum.UNFORMATED_NPI;
        case 70:
        case 'FORMATTED_NPI':
            return CAPIDEnum.FORMATTED_NPI;
        case 71:
        case 'ZIPFULLONLY':
            return CAPIDEnum.ZIPFULLONLY;
        case 72:
        case 'ZIPWITHTAG':
            return CAPIDEnum.ZIPWITHTAG;
        case 73:
        case 'FULLNAMEWITHTAG':
            return CAPIDEnum.FULLNAMEWITHTAG;
        case 74:
        case 'ADDRESSONLY':
            return CAPIDEnum.ADDRESSONLY;
        case 75:
        case 'ADDRESSWITHTAGS':
            return CAPIDEnum.ADDRESSWITHTAGS;
        case 76:
        case 'AGEWITHTAGS':
            return CAPIDEnum.AGEWITHTAGS;
        case 77:
        case 'PHONEFORMATTED':
            return CAPIDEnum.PHONEFORMATTED;
        case 78:
        case 'PHONEWITHTAGS':
            return CAPIDEnum.PHONEWITHTAGS;
        case 79:
        case 'EMAILFORMATTED':
            return CAPIDEnum.EMAILFORMATTED;
        case 80:
        case 'EMAILWITHTAGS':
            return CAPIDEnum.EMAILWITHTAGS;
        case 81:
        case 'AL_LP':
            return CAPIDEnum.AL_LP;
        case 82:
        case 'AK_LP':
            return CAPIDEnum.AK_LP;
        case 83:
        case 'AZ_LP':
            return CAPIDEnum.AZ_LP;
        case 84:
        case 'AR_LP':
            return CAPIDEnum.AR_LP;
        case 85:
        case 'CA_LP':
            return CAPIDEnum.CA_LP;
        case 86:
        case 'CO_LP':
            return CAPIDEnum.CO_LP;
        case 87:
        case 'CT_LP':
            return CAPIDEnum.CT_LP;
        case 88:
        case 'DE_LP':
            return CAPIDEnum.DE_LP;
        case 89:
        case 'DC_LP':
            return CAPIDEnum.DC_LP;
        case 90:
        case 'FL_LP':
            return CAPIDEnum.FL_LP;
        case 91:
        case 'GA_LP':
            return CAPIDEnum.GA_LP;
        case 92:
        case 'HI_LP':
            return CAPIDEnum.HI_LP;
        case 93:
        case 'ID_LP':
            return CAPIDEnum.ID_LP;
        case 94:
        case 'IL_LP':
            return CAPIDEnum.IL_LP;
        case 95:
        case 'IN_LP':
            return CAPIDEnum.IN_LP;
        case 96:
        case 'IA_LP':
            return CAPIDEnum.IA_LP;
        case 97:
        case 'KS_LP':
            return CAPIDEnum.KS_LP;
        case 98:
        case 'KY_LP':
            return CAPIDEnum.KY_LP;
        case 99:
        case 'LA_LP':
            return CAPIDEnum.LA_LP;
        case 100:
        case 'ME_LP':
            return CAPIDEnum.ME_LP;
        case 101:
        case 'MD_LP':
            return CAPIDEnum.MD_LP;
        case 102:
        case 'MA_LP':
            return CAPIDEnum.MA_LP;
        case 103:
        case 'MI_LP':
            return CAPIDEnum.MI_LP;
        case 104:
        case 'MN_LP':
            return CAPIDEnum.MN_LP;
        case 105:
        case 'MS_LP':
            return CAPIDEnum.MS_LP;
        case 106:
        case 'MO_LP':
            return CAPIDEnum.MO_LP;
        case 107:
        case 'MT_LP':
            return CAPIDEnum.MT_LP;
        case 108:
        case 'NE_LP':
            return CAPIDEnum.NE_LP;
        case 109:
        case 'NV_LP':
            return CAPIDEnum.NV_LP;
        case 110:
        case 'NH_LP':
            return CAPIDEnum.NH_LP;
        case 111:
        case 'NJ_LP':
            return CAPIDEnum.NJ_LP;
        case 112:
        case 'NM_LP':
            return CAPIDEnum.NM_LP;
        case 113:
        case 'NY_LP':
            return CAPIDEnum.NY_LP;
        case 114:
        case 'NC_LP':
            return CAPIDEnum.NC_LP;
        case 115:
        case 'ND_LP':
            return CAPIDEnum.ND_LP;
        case 116:
        case 'OH_LP':
            return CAPIDEnum.OH_LP;
        case 117:
        case 'OK_LP':
            return CAPIDEnum.OK_LP;
        case 118:
        case 'OR_LP':
            return CAPIDEnum.OR_LP;
        case 119:
        case 'PA_LP':
            return CAPIDEnum.PA_LP;
        case 120:
        case 'RI_LP':
            return CAPIDEnum.RI_LP;
        case 121:
        case 'SC_LP':
            return CAPIDEnum.SC_LP;
        case 122:
        case 'SD_LP':
            return CAPIDEnum.SD_LP;
        case 123:
        case 'TN_LP':
            return CAPIDEnum.TN_LP;
        case 124:
        case 'TX_LP':
            return CAPIDEnum.TX_LP;
        case 125:
        case 'UT_LP':
            return CAPIDEnum.UT_LP;
        case 126:
        case 'VT_LP':
            return CAPIDEnum.VT_LP;
        case 127:
        case 'VA_LP':
            return CAPIDEnum.VA_LP;
        case 128:
        case 'WA_LP':
            return CAPIDEnum.WA_LP;
        case 129:
        case 'WV_LP':
            return CAPIDEnum.WV_LP;
        case 130:
        case 'WI_LP':
            return CAPIDEnum.WI_LP;
        case 131:
        case 'WY_LP':
            return CAPIDEnum.WY_LP;
        case 132:
        case 'VIN_WITH_TAGS':
            return CAPIDEnum.VIN_WITH_TAGS;
        case 133:
        case 'URL_ONLY':
            return CAPIDEnum.URL_ONLY;
        case 134:
        case 'URL_WITH_TAGS':
            return CAPIDEnum.URL_WITH_TAGS;
        case 135:
        case 'IPONLY':
            return CAPIDEnum.IPONLY;
        case 136:
        case 'IP_WITH_TAGS':
            return CAPIDEnum.IP_WITH_TAGS;
        case 137:
        case 'ACCT_SECURITY_TAGS':
            return CAPIDEnum.ACCT_SECURITY_TAGS;
        case 138:
        case 'VISA_CC':
            return CAPIDEnum.VISA_CC;
        case 139:
        case 'MASTERCARD_CC':
            return CAPIDEnum.MASTERCARD_CC;
        case 140:
        case 'AMEX_CC':
            return CAPIDEnum.AMEX_CC;
        case 141:
        case 'DISCOVER_CC':
            return CAPIDEnum.DISCOVER_CC;
        case 142:
        case 'ALL_CC':
            return CAPIDEnum.ALL_CC;
        case 143:
        case 'IBAN_ONLY':
            return CAPIDEnum.IBAN_ONLY;
        case 144:
        case 'IBAN_TAGS':
            return CAPIDEnum.IBAN_TAGS;
        case 145:
        case 'USBAI_NUMONLY':
            return CAPIDEnum.USBAI_NUMONLY;
        case 146:
        case 'USBAI_TAGSONLY':
            return CAPIDEnum.USBAI_TAGSONLY;
        case 147:
        case 'USBAI_TAGS_NUMBER':
            return CAPIDEnum.USBAI_TAGS_NUMBER;
        case 148:
        case 'MCS_TAGSIDC910':
            return CAPIDEnum.MCS_TAGSIDC910;
        case 149:
        case 'WTI_TAGS_SWIFT':
            return CAPIDEnum.WTI_TAGS_SWIFT;
        case 150:
        case 'SSN9_DLN':
            return CAPIDEnum.SSN9_DLN;
        case 151:
        case 'TIN9_DLN':
            return CAPIDEnum.TIN9_DLN;
        case 152:
        case 'EIN9_DLN':
            return CAPIDEnum.EIN9_DLN;
        case 153:
        case 'SSNTINEIN9_DLN':
            return CAPIDEnum.SSNTINEIN9_DLN;
        case 154:
        case 'SSNTINEIN9_PASSPORT':
            return CAPIDEnum.SSNTINEIN9_PASSPORT;
        case 155:
        case 'SSNTINEIN9_MED_TERMS':
            return CAPIDEnum.SSNTINEIN9_MED_TERMS;
        case 156:
        case 'SSNTINEIN9_CC':
            return CAPIDEnum.SSNTINEIN9_CC;
        case 157:
        case 'SSNTINEIN9_BANK_ACCT':
            return CAPIDEnum.SSNTINEIN9_BANK_ACCT;
        case 158:
        case 'UNSCANNED_FILES':
            return CAPIDEnum.UNSCANNED_FILES;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CAPIDEnum.UNRECOGNIZED;
    }
}
export function cAPIDEnumToJSON(object) {
    switch (object) {
        case CAPIDEnum.UNDEFINED:
            return 'UNDEFINED';
        case CAPIDEnum.FORMATTED_USSSN:
            return 'FORMATTED_USSSN';
        case CAPIDEnum.USSSN_TAGS:
            return 'USSSN_TAGS';
        case CAPIDEnum.FORMATTED_USTIN:
            return 'FORMATTED_USTIN';
        case CAPIDEnum.USTIN_TAGS:
            return 'USTIN_TAGS';
        case CAPIDEnum.FORMATTED_USEIN:
            return 'FORMATTED_USEIN';
        case CAPIDEnum.USEIN_TAGS:
            return 'USEIN_TAGS';
        case CAPIDEnum.AL_DL:
            return 'AL_DL';
        case CAPIDEnum.AK_DL:
            return 'AK_DL';
        case CAPIDEnum.AZ_DL:
            return 'AZ_DL';
        case CAPIDEnum.AR_DL:
            return 'AR_DL';
        case CAPIDEnum.CA_DL:
            return 'CA_DL';
        case CAPIDEnum.CO_DL:
            return 'CO_DL';
        case CAPIDEnum.CT_DL:
            return 'CT_DL';
        case CAPIDEnum.DE_DL:
            return 'DE_DL';
        case CAPIDEnum.DC_DL:
            return 'DC_DL';
        case CAPIDEnum.FL_DL:
            return 'FL_DL';
        case CAPIDEnum.GA_DL:
            return 'GA_DL';
        case CAPIDEnum.HI_DL:
            return 'HI_DL';
        case CAPIDEnum.ID_DL:
            return 'ID_DL';
        case CAPIDEnum.IL_DL:
            return 'IL_DL';
        case CAPIDEnum.IN_DL:
            return 'IN_DL';
        case CAPIDEnum.IA_DL:
            return 'IA_DL';
        case CAPIDEnum.KS_DL:
            return 'KS_DL';
        case CAPIDEnum.KY_DL:
            return 'KY_DL';
        case CAPIDEnum.LA_DL:
            return 'LA_DL';
        case CAPIDEnum.ME_DL:
            return 'ME_DL';
        case CAPIDEnum.MD_DL:
            return 'MD_DL';
        case CAPIDEnum.MA_DL:
            return 'MA_DL';
        case CAPIDEnum.MI_DL:
            return 'MI_DL';
        case CAPIDEnum.MN_DL:
            return 'MN_DL';
        case CAPIDEnum.MS_DL:
            return 'MS_DL';
        case CAPIDEnum.MO_DL:
            return 'MO_DL';
        case CAPIDEnum.MT_DL:
            return 'MT_DL';
        case CAPIDEnum.NE_DL:
            return 'NE_DL';
        case CAPIDEnum.NV_DL:
            return 'NV_DL';
        case CAPIDEnum.NH_DL:
            return 'NH_DL';
        case CAPIDEnum.NJ_DL:
            return 'NJ_DL';
        case CAPIDEnum.NM_DL:
            return 'NM_DL';
        case CAPIDEnum.NY_DL:
            return 'NY_DL';
        case CAPIDEnum.NC_DL:
            return 'NC_DL';
        case CAPIDEnum.ND_DL:
            return 'ND_DL';
        case CAPIDEnum.OH_DL:
            return 'OH_DL';
        case CAPIDEnum.OK_DL:
            return 'OK_DL';
        case CAPIDEnum.OR_DL:
            return 'OR_DL';
        case CAPIDEnum.PA_DL:
            return 'PA_DL';
        case CAPIDEnum.RI_DL:
            return 'RI_DL';
        case CAPIDEnum.SC_DL:
            return 'SC_DL';
        case CAPIDEnum.SD_DL:
            return 'SD_DL';
        case CAPIDEnum.TN_DL:
            return 'TN_DL';
        case CAPIDEnum.TX_DL:
            return 'TX_DL';
        case CAPIDEnum.UT_DL:
            return 'UT_DL';
        case CAPIDEnum.VT_DL:
            return 'VT_DL';
        case CAPIDEnum.VA_DL:
            return 'VA_DL';
        case CAPIDEnum.WA_DL:
            return 'WA_DL';
        case CAPIDEnum.WV_DL:
            return 'WV_DL';
        case CAPIDEnum.WI_DL:
            return 'WI_DL';
        case CAPIDEnum.WY_DL:
            return 'WY_DL';
        case CAPIDEnum.US_PASSPORT:
            return 'US_PASSPORT';
        case CAPIDEnum.US_DATEONLY:
            return 'US_DATEONLY';
        case CAPIDEnum.DATE_OF:
            return 'DATE_OF';
        case CAPIDEnum.DATE_OF_BIRTH:
            return 'DATE_OF_BIRTH';
        case CAPIDEnum.DATE_OF_SERVICE:
            return 'DATE_OF_SERVICE';
        case CAPIDEnum.DATE_OF_ADMISSION:
            return 'DATE_OF_ADMISSION';
        case CAPIDEnum.DATE_OF_DISCHARGE:
            return 'DATE_OF_DISCHARGE';
        case CAPIDEnum.DATE_OF_DEATH:
            return 'DATE_OF_DEATH';
        case CAPIDEnum.RECEIVED_DATE:
            return 'RECEIVED_DATE';
        case CAPIDEnum.ORDER_DATE:
            return 'ORDER_DATE';
        case CAPIDEnum.EXP_DATE:
            return 'EXP_DATE';
        case CAPIDEnum.UNFORMATED_NPI:
            return 'UNFORMATED_NPI';
        case CAPIDEnum.FORMATTED_NPI:
            return 'FORMATTED_NPI';
        case CAPIDEnum.ZIPFULLONLY:
            return 'ZIPFULLONLY';
        case CAPIDEnum.ZIPWITHTAG:
            return 'ZIPWITHTAG';
        case CAPIDEnum.FULLNAMEWITHTAG:
            return 'FULLNAMEWITHTAG';
        case CAPIDEnum.ADDRESSONLY:
            return 'ADDRESSONLY';
        case CAPIDEnum.ADDRESSWITHTAGS:
            return 'ADDRESSWITHTAGS';
        case CAPIDEnum.AGEWITHTAGS:
            return 'AGEWITHTAGS';
        case CAPIDEnum.PHONEFORMATTED:
            return 'PHONEFORMATTED';
        case CAPIDEnum.PHONEWITHTAGS:
            return 'PHONEWITHTAGS';
        case CAPIDEnum.EMAILFORMATTED:
            return 'EMAILFORMATTED';
        case CAPIDEnum.EMAILWITHTAGS:
            return 'EMAILWITHTAGS';
        case CAPIDEnum.AL_LP:
            return 'AL_LP';
        case CAPIDEnum.AK_LP:
            return 'AK_LP';
        case CAPIDEnum.AZ_LP:
            return 'AZ_LP';
        case CAPIDEnum.AR_LP:
            return 'AR_LP';
        case CAPIDEnum.CA_LP:
            return 'CA_LP';
        case CAPIDEnum.CO_LP:
            return 'CO_LP';
        case CAPIDEnum.CT_LP:
            return 'CT_LP';
        case CAPIDEnum.DE_LP:
            return 'DE_LP';
        case CAPIDEnum.DC_LP:
            return 'DC_LP';
        case CAPIDEnum.FL_LP:
            return 'FL_LP';
        case CAPIDEnum.GA_LP:
            return 'GA_LP';
        case CAPIDEnum.HI_LP:
            return 'HI_LP';
        case CAPIDEnum.ID_LP:
            return 'ID_LP';
        case CAPIDEnum.IL_LP:
            return 'IL_LP';
        case CAPIDEnum.IN_LP:
            return 'IN_LP';
        case CAPIDEnum.IA_LP:
            return 'IA_LP';
        case CAPIDEnum.KS_LP:
            return 'KS_LP';
        case CAPIDEnum.KY_LP:
            return 'KY_LP';
        case CAPIDEnum.LA_LP:
            return 'LA_LP';
        case CAPIDEnum.ME_LP:
            return 'ME_LP';
        case CAPIDEnum.MD_LP:
            return 'MD_LP';
        case CAPIDEnum.MA_LP:
            return 'MA_LP';
        case CAPIDEnum.MI_LP:
            return 'MI_LP';
        case CAPIDEnum.MN_LP:
            return 'MN_LP';
        case CAPIDEnum.MS_LP:
            return 'MS_LP';
        case CAPIDEnum.MO_LP:
            return 'MO_LP';
        case CAPIDEnum.MT_LP:
            return 'MT_LP';
        case CAPIDEnum.NE_LP:
            return 'NE_LP';
        case CAPIDEnum.NV_LP:
            return 'NV_LP';
        case CAPIDEnum.NH_LP:
            return 'NH_LP';
        case CAPIDEnum.NJ_LP:
            return 'NJ_LP';
        case CAPIDEnum.NM_LP:
            return 'NM_LP';
        case CAPIDEnum.NY_LP:
            return 'NY_LP';
        case CAPIDEnum.NC_LP:
            return 'NC_LP';
        case CAPIDEnum.ND_LP:
            return 'ND_LP';
        case CAPIDEnum.OH_LP:
            return 'OH_LP';
        case CAPIDEnum.OK_LP:
            return 'OK_LP';
        case CAPIDEnum.OR_LP:
            return 'OR_LP';
        case CAPIDEnum.PA_LP:
            return 'PA_LP';
        case CAPIDEnum.RI_LP:
            return 'RI_LP';
        case CAPIDEnum.SC_LP:
            return 'SC_LP';
        case CAPIDEnum.SD_LP:
            return 'SD_LP';
        case CAPIDEnum.TN_LP:
            return 'TN_LP';
        case CAPIDEnum.TX_LP:
            return 'TX_LP';
        case CAPIDEnum.UT_LP:
            return 'UT_LP';
        case CAPIDEnum.VT_LP:
            return 'VT_LP';
        case CAPIDEnum.VA_LP:
            return 'VA_LP';
        case CAPIDEnum.WA_LP:
            return 'WA_LP';
        case CAPIDEnum.WV_LP:
            return 'WV_LP';
        case CAPIDEnum.WI_LP:
            return 'WI_LP';
        case CAPIDEnum.WY_LP:
            return 'WY_LP';
        case CAPIDEnum.VIN_WITH_TAGS:
            return 'VIN_WITH_TAGS';
        case CAPIDEnum.URL_ONLY:
            return 'URL_ONLY';
        case CAPIDEnum.URL_WITH_TAGS:
            return 'URL_WITH_TAGS';
        case CAPIDEnum.IPONLY:
            return 'IPONLY';
        case CAPIDEnum.IP_WITH_TAGS:
            return 'IP_WITH_TAGS';
        case CAPIDEnum.ACCT_SECURITY_TAGS:
            return 'ACCT_SECURITY_TAGS';
        case CAPIDEnum.VISA_CC:
            return 'VISA_CC';
        case CAPIDEnum.MASTERCARD_CC:
            return 'MASTERCARD_CC';
        case CAPIDEnum.AMEX_CC:
            return 'AMEX_CC';
        case CAPIDEnum.DISCOVER_CC:
            return 'DISCOVER_CC';
        case CAPIDEnum.ALL_CC:
            return 'ALL_CC';
        case CAPIDEnum.IBAN_ONLY:
            return 'IBAN_ONLY';
        case CAPIDEnum.IBAN_TAGS:
            return 'IBAN_TAGS';
        case CAPIDEnum.USBAI_NUMONLY:
            return 'USBAI_NUMONLY';
        case CAPIDEnum.USBAI_TAGSONLY:
            return 'USBAI_TAGSONLY';
        case CAPIDEnum.USBAI_TAGS_NUMBER:
            return 'USBAI_TAGS_NUMBER';
        case CAPIDEnum.MCS_TAGSIDC910:
            return 'MCS_TAGSIDC910';
        case CAPIDEnum.WTI_TAGS_SWIFT:
            return 'WTI_TAGS_SWIFT';
        case CAPIDEnum.SSN9_DLN:
            return 'SSN9_DLN';
        case CAPIDEnum.TIN9_DLN:
            return 'TIN9_DLN';
        case CAPIDEnum.EIN9_DLN:
            return 'EIN9_DLN';
        case CAPIDEnum.SSNTINEIN9_DLN:
            return 'SSNTINEIN9_DLN';
        case CAPIDEnum.SSNTINEIN9_PASSPORT:
            return 'SSNTINEIN9_PASSPORT';
        case CAPIDEnum.SSNTINEIN9_MED_TERMS:
            return 'SSNTINEIN9_MED_TERMS';
        case CAPIDEnum.SSNTINEIN9_CC:
            return 'SSNTINEIN9_CC';
        case CAPIDEnum.SSNTINEIN9_BANK_ACCT:
            return 'SSNTINEIN9_BANK_ACCT';
        case CAPIDEnum.UNSCANNED_FILES:
            return 'UNSCANNED_FILES';
        case CAPIDEnum.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
function createBaseCAPCheck() {
    return {
        Enabled: false,
        CAPID: 0,
        Description: '',
        Process: 0,
        Severity: 0,
        DRM: 0,
        Type: 0,
        Regex: '',
        Terms: '',
        Formats: '',
        MMList: []
    };
}
export const CAPCheck = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.Enabled === true) {
            writer.uint32(8).bool(message.Enabled);
        }
        if (message.CAPID !== 0) {
            writer.uint32(16).int32(message.CAPID);
        }
        if (message.Description !== '') {
            writer.uint32(26).string(message.Description);
        }
        if (message.Process !== 0) {
            writer.uint32(32).int32(message.Process);
        }
        if (message.Severity !== 0) {
            writer.uint32(40).int32(message.Severity);
        }
        if (message.DRM !== 0) {
            writer.uint32(48).int32(message.DRM);
        }
        if (message.Type !== 0) {
            writer.uint32(56).int32(message.Type);
        }
        if (message.Regex !== '') {
            writer.uint32(66).string(message.Regex);
        }
        if (message.Terms !== '') {
            writer.uint32(74).string(message.Terms);
        }
        if (message.Formats !== '') {
            writer.uint32(82).string(message.Formats);
        }
        writer.uint32(90).fork();
        for (const v of message.MMList) {
            writer.int32(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCAPCheck();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.Enabled = reader.bool();
                    break;
                case 2:
                    message.CAPID = reader.int32();
                    break;
                case 3:
                    message.Description = reader.string();
                    break;
                case 4:
                    message.Process = reader.int32();
                    break;
                case 5:
                    message.Severity = reader.int32();
                    break;
                case 6:
                    message.DRM = reader.int32();
                    break;
                case 7:
                    message.Type = reader.int32();
                    break;
                case 8:
                    message.Regex = reader.string();
                    break;
                case 9:
                    message.Terms = reader.string();
                    break;
                case 10:
                    message.Formats = reader.string();
                    break;
                case 11:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.MMList.push(reader.int32());
                        }
                    }
                    else {
                        message.MMList.push(reader.int32());
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            Enabled: isSet(object.Enabled) ? Boolean(object.Enabled) : false,
            CAPID: isSet(object.CAPID) ? cAPIDEnumFromJSON(object.CAPID) : 0,
            Description: isSet(object.Description) ? String(object.Description) : '',
            Process: isSet(object.Process) ? cAPProcessFromJSON(object.Process) : 0,
            Severity: isSet(object.Severity)
                ? cAPSeverityFromJSON(object.Severity)
                : 0,
            DRM: isSet(object.DRM) ? cAPDRMFromJSON(object.DRM) : 0,
            Type: isSet(object.Type) ? cAPTypeFromJSON(object.Type) : 0,
            Regex: isSet(object.Regex) ? String(object.Regex) : '',
            Terms: isSet(object.Terms) ? String(object.Terms) : '',
            Formats: isSet(object.Formats) ? String(object.Formats) : '',
            MMList: Array.isArray(object === null || object === void 0 ? void 0 : object.MMList)
                ? object.MMList.map((e) => cAPIDEnumFromJSON(e))
                : []
        };
    },
    toJSON(message) {
        const obj = {};
        message.Enabled !== undefined && (obj.Enabled = message.Enabled);
        message.CAPID !== undefined && (obj.CAPID = cAPIDEnumToJSON(message.CAPID));
        message.Description !== undefined &&
            (obj.Description = message.Description);
        message.Process !== undefined &&
            (obj.Process = cAPProcessToJSON(message.Process));
        message.Severity !== undefined &&
            (obj.Severity = cAPSeverityToJSON(message.Severity));
        message.DRM !== undefined && (obj.DRM = cAPDRMToJSON(message.DRM));
        message.Type !== undefined && (obj.Type = cAPTypeToJSON(message.Type));
        message.Regex !== undefined && (obj.Regex = message.Regex);
        message.Terms !== undefined && (obj.Terms = message.Terms);
        message.Formats !== undefined && (obj.Formats = message.Formats);
        if (message.MMList) {
            obj.MMList = message.MMList.map((e) => cAPIDEnumToJSON(e));
        }
        else {
            obj.MMList = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const message = createBaseCAPCheck();
        message.Enabled = (_a = object.Enabled) !== null && _a !== void 0 ? _a : false;
        message.CAPID = (_b = object.CAPID) !== null && _b !== void 0 ? _b : 0;
        message.Description = (_c = object.Description) !== null && _c !== void 0 ? _c : '';
        message.Process = (_d = object.Process) !== null && _d !== void 0 ? _d : 0;
        message.Severity = (_e = object.Severity) !== null && _e !== void 0 ? _e : 0;
        message.DRM = (_f = object.DRM) !== null && _f !== void 0 ? _f : 0;
        message.Type = (_g = object.Type) !== null && _g !== void 0 ? _g : 0;
        message.Regex = (_h = object.Regex) !== null && _h !== void 0 ? _h : '';
        message.Terms = (_j = object.Terms) !== null && _j !== void 0 ? _j : '';
        message.Formats = (_k = object.Formats) !== null && _k !== void 0 ? _k : '';
        message.MMList = ((_l = object.MMList) === null || _l === void 0 ? void 0 : _l.map((e) => e)) || [];
        return message;
    }
};
function createBaseCAPCheckList() {
    return { ccList: [], PassiveMode: false };
}
export const CAPCheckList = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.ccList) {
            CAPCheck.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.PassiveMode === true) {
            writer.uint32(16).bool(message.PassiveMode);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCAPCheckList();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.ccList.push(CAPCheck.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.PassiveMode = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            ccList: Array.isArray(object === null || object === void 0 ? void 0 : object.ccList)
                ? object.ccList.map((e) => CAPCheck.fromJSON(e))
                : [],
            PassiveMode: isSet(object.PassiveMode)
                ? Boolean(object.PassiveMode)
                : false
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.ccList) {
            obj.ccList = message.ccList.map((e) => e ? CAPCheck.toJSON(e) : undefined);
        }
        else {
            obj.ccList = [];
        }
        message.PassiveMode !== undefined &&
            (obj.PassiveMode = message.PassiveMode);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseCAPCheckList();
        message.ccList = ((_a = object.ccList) === null || _a === void 0 ? void 0 : _a.map((e) => CAPCheck.fromPartial(e))) || [];
        message.PassiveMode = (_b = object.PassiveMode) !== null && _b !== void 0 ? _b : false;
        return message;
    }
};
function createBaseCAPMatch() {
    return { Index: 0, Length: 0, Match: '' };
}
export const CAPMatch = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.Index !== 0) {
            writer.uint32(8).int32(message.Index);
        }
        if (message.Length !== 0) {
            writer.uint32(16).int32(message.Length);
        }
        if (message.Match !== '') {
            writer.uint32(26).string(message.Match);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCAPMatch();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.Index = reader.int32();
                    break;
                case 2:
                    message.Length = reader.int32();
                    break;
                case 3:
                    message.Match = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            Index: isSet(object.Index) ? Number(object.Index) : 0,
            Length: isSet(object.Length) ? Number(object.Length) : 0,
            Match: isSet(object.Match) ? String(object.Match) : ''
        };
    },
    toJSON(message) {
        const obj = {};
        message.Index !== undefined && (obj.Index = Math.round(message.Index));
        message.Length !== undefined && (obj.Length = Math.round(message.Length));
        message.Match !== undefined && (obj.Match = message.Match);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseCAPMatch();
        message.Index = (_a = object.Index) !== null && _a !== void 0 ? _a : 0;
        message.Length = (_b = object.Length) !== null && _b !== void 0 ? _b : 0;
        message.Match = (_c = object.Match) !== null && _c !== void 0 ? _c : '';
        return message;
    }
};
function createBaseCAPViolation() {
    return {
        Severity: 0,
        DRM: 0,
        RuleId: 0,
        FileName: '',
        VioDescription: '',
        MatchList: [],
        VioReason: ''
    };
}
export const CAPViolation = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.Severity !== 0) {
            writer.uint32(8).int32(message.Severity);
        }
        if (message.DRM !== 0) {
            writer.uint32(16).int32(message.DRM);
        }
        if (message.RuleId !== 0) {
            writer.uint32(24).int32(message.RuleId);
        }
        if (message.FileName !== '') {
            writer.uint32(34).string(message.FileName);
        }
        if (message.VioDescription !== '') {
            writer.uint32(42).string(message.VioDescription);
        }
        for (const v of message.MatchList) {
            CAPMatch.encode(v, writer.uint32(50).fork()).ldelim();
        }
        if (message.VioReason !== '') {
            writer.uint32(58).string(message.VioReason);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCAPViolation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.Severity = reader.int32();
                    break;
                case 2:
                    message.DRM = reader.int32();
                    break;
                case 3:
                    message.RuleId = reader.int32();
                    break;
                case 4:
                    message.FileName = reader.string();
                    break;
                case 5:
                    message.VioDescription = reader.string();
                    break;
                case 6:
                    message.MatchList.push(CAPMatch.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.VioReason = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            Severity: isSet(object.Severity)
                ? cAPSeverityFromJSON(object.Severity)
                : 0,
            DRM: isSet(object.DRM) ? cAPDRMFromJSON(object.DRM) : 0,
            RuleId: isSet(object.RuleId) ? cAPIDEnumFromJSON(object.RuleId) : 0,
            FileName: isSet(object.FileName) ? String(object.FileName) : '',
            VioDescription: isSet(object.VioDescription)
                ? String(object.VioDescription)
                : '',
            MatchList: Array.isArray(object === null || object === void 0 ? void 0 : object.MatchList)
                ? object.MatchList.map((e) => CAPMatch.fromJSON(e))
                : [],
            VioReason: isSet(object.VioReason) ? String(object.VioReason) : ''
        };
    },
    toJSON(message) {
        const obj = {};
        message.Severity !== undefined &&
            (obj.Severity = cAPSeverityToJSON(message.Severity));
        message.DRM !== undefined && (obj.DRM = cAPDRMToJSON(message.DRM));
        message.RuleId !== undefined &&
            (obj.RuleId = cAPIDEnumToJSON(message.RuleId));
        message.FileName !== undefined && (obj.FileName = message.FileName);
        message.VioDescription !== undefined &&
            (obj.VioDescription = message.VioDescription);
        if (message.MatchList) {
            obj.MatchList = message.MatchList.map((e) => e ? CAPMatch.toJSON(e) : undefined);
        }
        else {
            obj.MatchList = [];
        }
        message.VioReason !== undefined && (obj.VioReason = message.VioReason);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = createBaseCAPViolation();
        message.Severity = (_a = object.Severity) !== null && _a !== void 0 ? _a : 0;
        message.DRM = (_b = object.DRM) !== null && _b !== void 0 ? _b : 0;
        message.RuleId = (_c = object.RuleId) !== null && _c !== void 0 ? _c : 0;
        message.FileName = (_d = object.FileName) !== null && _d !== void 0 ? _d : '';
        message.VioDescription = (_e = object.VioDescription) !== null && _e !== void 0 ? _e : '';
        message.MatchList =
            ((_f = object.MatchList) === null || _f === void 0 ? void 0 : _f.map((e) => CAPMatch.fromPartial(e))) || [];
        message.VioReason = (_g = object.VioReason) !== null && _g !== void 0 ? _g : '';
        return message;
    }
};
function createBaseCAPVioList() {
    return { CapVio: [] };
}
export const CAPVioList = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.CapVio) {
            CAPViolation.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCAPVioList();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.CapVio.push(CAPViolation.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            CapVio: Array.isArray(object === null || object === void 0 ? void 0 : object.CapVio)
                ? object.CapVio.map((e) => CAPViolation.fromJSON(e))
                : []
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.CapVio) {
            obj.CapVio = message.CapVio.map((e) => e ? CAPViolation.toJSON(e) : undefined);
        }
        else {
            obj.CapVio = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseCAPVioList();
        message.CapVio =
            ((_a = object.CapVio) === null || _a === void 0 ? void 0 : _a.map((e) => CAPViolation.fromPartial(e))) || [];
        return message;
    }
};
function createBaseCAPDataTest() {
    return { testData: '', pass: false };
}
export const CAPDataTest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.testData !== '') {
            writer.uint32(10).string(message.testData);
        }
        if (message.pass === true) {
            writer.uint32(16).bool(message.pass);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCAPDataTest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.testData = reader.string();
                    break;
                case 2:
                    message.pass = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            testData: isSet(object.testData) ? String(object.testData) : '',
            pass: isSet(object.pass) ? Boolean(object.pass) : false
        };
    },
    toJSON(message) {
        const obj = {};
        message.testData !== undefined && (obj.testData = message.testData);
        message.pass !== undefined && (obj.pass = message.pass);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseCAPDataTest();
        message.testData = (_a = object.testData) !== null && _a !== void 0 ? _a : '';
        message.pass = (_b = object.pass) !== null && _b !== void 0 ? _b : false;
        return message;
    }
};
function createBaseCAPData() {
    return { CAPID: 0, TestData: '', RegExReq: '' };
}
export const CAPData = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.CAPID !== 0) {
            writer.uint32(8).int32(message.CAPID);
        }
        if (message.TestData !== '') {
            writer.uint32(18).string(message.TestData);
        }
        if (message.RegExReq !== '') {
            writer.uint32(26).string(message.RegExReq);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCAPData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.CAPID = reader.int32();
                    break;
                case 2:
                    message.TestData = reader.string();
                    break;
                case 3:
                    message.RegExReq = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            CAPID: isSet(object.CAPID) ? cAPIDEnumFromJSON(object.CAPID) : 0,
            TestData: isSet(object.TestData) ? String(object.TestData) : '',
            RegExReq: isSet(object.RegExReq) ? String(object.RegExReq) : ''
        };
    },
    toJSON(message) {
        const obj = {};
        message.CAPID !== undefined && (obj.CAPID = cAPIDEnumToJSON(message.CAPID));
        message.TestData !== undefined && (obj.TestData = message.TestData);
        message.RegExReq !== undefined && (obj.RegExReq = message.RegExReq);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseCAPData();
        message.CAPID = (_a = object.CAPID) !== null && _a !== void 0 ? _a : 0;
        message.TestData = (_b = object.TestData) !== null && _b !== void 0 ? _b : '';
        message.RegExReq = (_c = object.RegExReq) !== null && _c !== void 0 ? _c : '';
        return message;
    }
};
function createBaseCAPDataList() {
    return { cdList: [] };
}
export const CAPDataList = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.cdList) {
            CAPData.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCAPDataList();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.cdList.push(CAPData.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            cdList: Array.isArray(object === null || object === void 0 ? void 0 : object.cdList)
                ? object.cdList.map((e) => CAPData.fromJSON(e))
                : []
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.cdList) {
            obj.cdList = message.cdList.map((e) => e ? CAPData.toJSON(e) : undefined);
        }
        else {
            obj.cdList = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseCAPDataList();
        message.cdList = ((_a = object.cdList) === null || _a === void 0 ? void 0 : _a.map((e) => CAPData.fromPartial(e))) || [];
        return message;
    }
};
function isSet(value) {
    return value !== null && value !== undefined;
}
